import {Skeleton} from "@mui/material";
import * as React from "react";
import {useRef} from "react";
import useDraggableScroll from "use-draggable-scroll";
import {css} from "@emotion/css"
import "./RaikoSelectBoxTypeTwo.scss";

export default function RaikoSelectBoxTypeTwo(
    {
        className,
        isHorizontal,
        loading,
        items,
        selectedItem,
        setSelectedItem,
        iconClass = "ic_residence"
    }) {

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: isHorizontal ? "horizontal" : "vertical"});


    const handleNewSelect = (id) => {
        setSelectedItem(id)
    };


    return (
        <section
            className={`raikoSelectBoxTypeTwoBaseContainer ${className} ${isHorizontal ? "raikoSelectBoxTypeTwoBaseContainerHorizontal" : "raikoSelectBoxTypeTwoBaseContainerVertical"}`}
            ref={ref}
            onMouseDown={onMouseDown}
        >
            <div className="raikoSelectBoxTypeTwoItemsContainer">
                {!loading &&
                    items.map((item) => (
                        <div
                            key={item.id}
                            className={`baseCardSize raikoHostSelectBoxItem ${
                                selectedItem === item.id ? "raikoHostSelectBoxItemActive" : ""
                            }`}
                            onClick={() => handleNewSelect(item.id)}
                        >
                            <div className="raikoSelectBoxItemsInfoContainer">
                                <div className={`${iconClass} raikoSelectBoxItemsInfoContainerIcon`}/>
                                <div className={"raikoSelectBoxItemsInfo"}>
                                    <span
                                        className={"residenceTitle"}>{item.title}</span>
                                    <span
                                        className={"residenceClerkName"}>{item.subTitle}</span>
                                </div>
                            </div>
                        </div>
                    ))}

                {loading &&

                    [...Array(4)].map((_, index) => (
                        <Skeleton
                            key={index}
                            variant="rectangular"
                            className={`baseCardSize ${css`
                                height: 110px !important;
                                width: 170px;
                            `}`}
                        />
                    ))

                }
            </div>


        </section>
    )
}


export function prepareRaikoSelectBoxTypeTwoItem(
    id,
    title,
    subTitle = "",
) {
    return {
        id,
        title,
        subTitle
    };
}